import { render, staticRenderFns } from "./HeaderSubSteps.vue?vue&type=template&id=52bbf16d&scoped=true&"
import script from "./HeaderSubSteps.vue?vue&type=script&lang=js&"
export * from "./HeaderSubSteps.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSubSteps.vue?vue&type=style&index=0&id=52bbf16d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bbf16d",
  null
  
)

export default component.exports